export default {
  id: 42,
  title: 'Target #42 - Baby',
  url: 'https://cssbattle.dev/play/42',
  colors: ['#293462', '#FE5F55', '#FFF1C1'],
  solution:
    '<a a><a b><a c><a d><a e><style>body{background:#293462}a{position:fixed}a[a]{top:50;left:100;background:#FE5F55;width:200;height:200;border-radius:100px 100px 50px 50px}a[b],a[c],a[d],a[e]{background:#FFF1C1}a[b],a[c],a[d]{border-radius:50%}a[b],a[c]{top:0;width:100;height:100}a[b]{left:100;clip-path:circle(100px at right 150px)}a[c]{left:200;clip-path:circle(100px at left 150px)}a[d]{width:60;height:60;top:140;left:120;box-shadow:100px 0 #FFF1C1}a[e]{top:220;left:180;width:40;height:10;border-radius:5px}</style>',
}
